import React from "react";
import "./Sustainability.css";
import bg from "./header_purple_new_on_v2.webp";
import image1 from "./factoid_2023_csr-tcfd.webp";
import image2 from "./totalgbvolume2x.webp";
import image3 from "./cbiscreened2x.webp";
import image4 from "./eurogovie2x.webp";
import image5 from "./eurocredit2x.webp";
import image6 from "./ushgcredit2x.webp";
import image7 from "./othergovbonds2x.webp";
import image8 from "./cbi-logo.webp";
import image9 from "./aiex_blog_mc-thumb.webp";
import image10 from "./data_points_etf_thumb.webp";
import image11 from "./news_release_thumb.webp";
const Sustainability = () => {
  return (
    <>
      <div className="purpose-section sustainability-section">
        <main
          id="main"
          className="reskin generic-content-page overflow-x-hidden sustainability-area"
        >
          <section
            className="jumbotron jumbotron-2 bg-size-cover d-flex position-relative w-100 p-0 mb-0"
            style={{
              backgroundImage: `url(${bg})`,
            }}
          >
            <div className="jumbotron-hero-header container">
              <h1
                className="m-0 font-slatepro-medium page-title display-size-1 color-white z-index-1 js-sr-intro-2 purpose-header-title"
                data-sr-id="1"
              >
                Sustainability Data &amp; Trading Insights
              </h1>
              <ol className="breadcrumb p-0 py-2 m-0 color-white">
                <li className="breadcrumb-item color-white z-index-1">
                  <a href="/" className="color-white no-underline">
                    Home Page
                  </a>
                </li>
                <li className="breadcrumb-item color-white z-index-1">
                  <a href="/" className="color-white no-underline">
                    Who We Are
                  </a>
                </li>
                <li className="breadcrumb-item color-white z-index-1">
                  <a href="#" className="color-white no-underline">
                    Sustainability Data &amp; Trading Insights
                  </a>
                </li>
              </ol>
            </div>
          </section>

          <div>
            <div>
              <section className="generic-content-block">
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-lg-6 display-size-11">
                      <p>
                        <span lang="EN-GB">
                           WLF Mobile holds a position as one of
                          the leading fixed income marketplaces for green bond
                          trading in the world, hosting an extensive global
                          community of institutional participants. We are
                          committed to doing our part to help financial markets
                          move toward a more sustainable global financial
                          system. With increased availability of sustainability
                          data and research we will have a better understanding
                          of potential operational opportunities for improvement
                          and related risks to address.
                        </span>
                      </p>
                      <h5
                        className="MsoNormal"
                        style={{
                          msoMarginBottomAlt: "auto",
                          lineHeight: "normal",
                          msoOutlineLevel: "2",
                          background: "white",
                        }}
                      >
                        <span
                          lang="EN-GB"
                          style={{ color: "rgb(0, 118, 168)" }}
                        >
                          Data&nbsp;&amp;&nbsp;Green Bond Functionality
                        </span>
                      </h5>
                      <p>
                        <span lang="EN-GB">
                          We offer clients simple access to all their green and
                          social bond trading needs, across a wide range of
                          asset classNamees.
                        </span>
                      </p>
                      <p>
                        <span lang="EN-GB">
                          2024* CBI screened Green Bonds accounted for $431.8B
                          of the total $452.5B in Green Bond trading volume
                          executed on  WLF Mobile. This
                          represents an increase of 45% from 2023.
                        </span>
                      </p>
                    </div>
                    <figure className="col-12 col-lg-6 figure pt-sm-5 pt-lg-0 pl-lg-5 text-center">
                      <a href="#">
                        <img
                          data-src={image1}
                          className="img-fluid"
                          alt="2023 CSR and TCFD Report"
                          src={image1}
                        />
                      </a>
                    </figure>
                  </div>
                </div>
              </section>
            </div>
            <div>
              <section className="generic-content-block">
                <div className="container">
                  <div className="row">
                    <div className="col-12 display-size-11">
                      <h5 style={{ marginTop: "0in", background: "white" }}>
                        <span
                          lang="EN-GB"
                          style={{ color: "rgb(0, 118, 168)" }}
                        >
                          2024* Green Bond Trading Volume Highlights
                        </span>
                      </h5>
                      <div className="responsive-stacked-table with-mobile-labels">
                        <div className="row">
                          <div className="col-12 text-center">
                            <div className="py-3">
                              <img
                                src={image2}
                                alt="Volumes icon"
                                width="180"
                                height="180"
                                className="m-auto"
                              />
                              <br />
                              <p className="responsive-stacked-table-p">
                                $452.5B
                              </p>
                              <p className="responsive-stacked-table-p2 ">
                                Total Green Bond Trading Volume
                              </p>
                            </div>
                          </div>

                          <div className="col-12 text-center">
                            <div className="py-3">
                              <img
                                src={image3}
                                alt="CBI screen icon"
                                width="180"
                                height="180"
                                className="m-auto"
                              />
                              <br />
                              <p className="responsive-stacked-table-p">
                                $431.8B
                              </p>
                              <p className="responsive-stacked-table-p2 ">
                                CBI Screened Green Bonds and $20.7B non-aligned
                                issuer labelled
                              </p>
                            </div>
                          </div>

                          <div className="col-12 text-center">
                            <div className="py-3">
                              <img
                                src={image4}
                                alt="Eurogovie icon"
                                width="180"
                                height="180"
                                className="m-auto"
                              />
                              <br />
                              <p className="responsive-stacked-table-p">
                                $245.2B
                              </p>
                              <p className="responsive-stacked-table-p2 ">
                                European Government Bonds
                              </p>
                            </div>
                          </div>

                          <div className="col-12 text-center">
                            <div className="py-3">
                              <img
                                src={image5}
                                alt="Eurocredit icon"
                                width="180"
                                height="180"
                                className="m-auto"
                              />
                              <br />
                              <p className="responsive-stacked-table-p">$68B</p>
                              <p className="responsive-stacked-table-p2 ">
                                European Credit
                              </p>
                            </div>
                          </div>

                          <div className="col-12 text-center">
                            <div className="py-3">
                              <img
                                src={image6}
                                alt="credit icon"
                                width="180"
                                height="180"
                                className="m-auto"
                              />
                              <br />
                              <p className="responsive-stacked-table-p">
                                $32.4B
                              </p>
                              <p className="responsive-stacked-table-p2 ">
                                U.S. High-Grade Credit
                              </p>
                            </div>
                          </div>

                          <div className="col-12 text-center">
                            <div className="py-3">
                              <img
                                src={image7}
                                alt="Govt bonds icon"
                                width="180"
                                height="180"
                                className="m-auto"
                              />
                              <br />
                              <p className="responsive-stacked-table-p">
                                $31.1
                              </p>
                              <p className="responsive-stacked-table-p2 ">
                                Other Government Bonds
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <p>
                        <br />
                        <br />
                      </p>
                      <h5 className="text-center pb-2">
                        <span
                          lang="EN-GB"
                          style={{ color: "rgb(0, 118, 168)" }}
                        >
                          Strengthening our Data&nbsp;
                        </span>
                      </h5>
                      <p>
                        <span
                          lang="EN-GB"
                          style={{ color: "rgb(0, 118, 168)" }}
                        >
                          <img src={image8} alt="CBI logo" className="m-auto pb-2" />
                        </span>
                      </p>
                      <p>
                        <span lang="EN-GB">
                          <a href="#" rel="noopener">
                            Climate Bonds Initiative
                          </a>
                          (CBI) is an international, investor-focused
                          not-for-profit and the only organisation working
                          solely on mobilising the $100 trillion bond market for
                          climate change solutions.  WLF Mobile
                          is an official Partner of CBI. As an active supporter
                          of the advancement of Green and Sustainable finance,
                          we are excited about this initiative and how it better
                          serves the needs of our clients. CBI data powers our
                          Green Bond trading volumes, providing clients with
                          desired transparency.
                        </span>
                      </p>
                     
                      <p>&nbsp;</p>
                    </div>
                  </div>
                </div>
              </section>
            </div>
           
          </div>
        </main>
      </div>
    </>
  );
};

export default Sustainability;
